// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__2RU4d","fullScreen":"loader_fullScreen__HlG3f","holder":"loader_holder__3UiI4"};